import { useTheme } from '@mui/material/styles'
import RequiredStar from '../RequiredStar'
import { useEffect } from 'react'

type Props = {
  placeholder?: string
  className?: string
  value?: any
  type?: any
  onChange?: any
  error?: any
  key?: number | string
  ref?: any
  maxLength?: number
  onPaste?: any
  name?: string
  id?: string
  disabled?: boolean
  defaultChecked?: boolean
  label?: any
  required?: boolean
  autoFocus?: boolean
  endAdornment?: any
  startAdornment?: any
  minDate?: any
  maxDate?: any
  accept?: string | any
  checked?: any
  onKeyDown?: any
  labelClass?: string
  rows?: number
}

const TextInput = (props: Props) => {
  const theme = useTheme()
  useEffect(() => {
    console.log('Primary color:', theme.palette.primary.main)
  }, [theme])
  const {
    required,
    label,
    placeholder,
    className,
    onChange,
    value,
    type,
    error,
    key,
    ref,
    maxLength,
    onPaste,
    name,
    id,
    disabled,
    defaultChecked,
    autoFocus,
    endAdornment,
    startAdornment,
    minDate,
    maxDate,
    accept,
    checked,
    onKeyDown,
    labelClass,
    rows,
  } = props

  return (
    <div className="relative">
      {label && (
        <label className={`font-semibold ${labelClass || ''}`} htmlFor={id}>
          {label}
          {required && <RequiredStar />}
        </label>
      )}
      {startAdornment && <div className={`absolute`}>{startAdornment}</div>}
      {type === 'textarea' ? (
        <textarea
          rows={rows}
          autoFocus={autoFocus}
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          key={key}
          ref={ref}
          maxLength={maxLength}
          onPaste={onPaste}
          className={`block w-full p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 ${error ? 'border-red-400 focus:ring-0' : ''} ${className}`}
        />
      ) : (
        <input
          checked={checked}
          accept={accept}
          min={minDate}
          max={maxDate}
          autoFocus={autoFocus}
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          key={key}
          ref={ref}
          maxLength={maxLength}
          onPaste={onPaste}
          className={`block w-full p-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2  ${error ? 'border-red-400 focus:ring-0' : ''} ${className}`}
          style={{ backgroundColor: type === 'checkbox' && value ? `${theme.palette.primary.main}` : '' }}
        />
      )}

      {endAdornment && <div className={`absolute ring-0`}>{endAdornment}</div>}
    </div>
  )
}

export default TextInput
